<template>
  <div>
    <b-card no-body>
      <b-tabs card>
        <!-- SHM TAB -->
        <b-tab title="Gráficas SHM">
          <div
            v-if="currentGroup == null"
            class="text-center"
            style="padding: 50px"
          >
            <p style="font-size: 0.8rem">
              Seleccione una agrupación para visualizar sus detalles
            </p>
          </div>
          <div v-else style="padding: 10px">
            <SHM ref="shmTab" />
          </div>
        </b-tab>


        <!-- Análisis SHM -->
        <b-tab title="Análisis SHM">
          <div
            v-if="currentGroup == null"
            class="text-center"
            style="padding: 50px"
          >
            <p style="font-size: 0.8rem">
              Seleccione una agrupación para visualizar sus detalles
            </p>
          </div>
          <div v-else style="padding: 10px">
            <DesvFreq ref="desvFreq" />
          </div>
        </b-tab>

        <!-- Parámetros relevantes -->
        <b-tab title="Sismografía">
          <div
            v-if="currentGroup == null"
            class="text-center"
            style="padding: 50px"
          >
            <p style="font-size: 0.8rem">
              Seleccione una agrupación para visualizar sus detalles
            </p>
          </div>
          <div v-else style="padding: 10px">
            <Sismo ref="sismoTab" />
          </div>          
        </b-tab>

        <!-- Configuracion SHM -->
        <b-tab title="Configuracion SHM">
          <div
            v-if="currentGroup == null"
            class="text-center"
            style="padding: 50px"
          >
            <p style="font-size: 0.8rem">
              Seleccione una agrupación para visualizar sus detalles
            </p>
          </div>
          <div v-else style="padding: 10px">
            <SHMConfig ref="shmconfigTab" />
          </div>             
        </b-tab>

        <!-- Alertas -->
        <b-tab title="Alertas">
          <div
            v-if="currentGroup == null"
            class="text-center"
            style="padding: 50px"
          >
            <p style="font-size: 0.8rem">
              Seleccione una agrupación para visualizar sus detalles
            </p>
          </div>
          <div v-else style="padding: 10px">
            <Alerts ref="alertTab" />
          </div>             
        </b-tab>
      </b-tabs>
    </b-card>
  </div>
</template>



<script>
import GroupService from "@/services/GroupService";
import SHM from "@/components/groups/tabs/SHM";
import DesvFreq from "@/components/groups/tabs/DesvFreq";
import Sismo from "@/components/groups/tabs/Sismografia";
import SHMConfig from "@/components/groups/tabs/SHMConfig";
import Alerts from "@/components/groups/tabs/Alerts";

export default {
  data() {
    return {
      tabIndex: 0,
      currentGroup: null,
      sensorGroupList: [],
    };
  },
  components: {
    SHM,
    Sismo,
    SHMConfig,
    DesvFreq,
    Alerts
  },
  mounted() {},
  methods: {
   retrieveGroupDetails(idgroup) {
      //Get device data
      GroupService.get(idgroup)
        .then((response) => {
          this.currentGroup = response.data;
        })
        .then((response) => {
         this.$refs.shmTab.requestChartLoad(this.currentGroup, 0)
         this.$refs.sismoTab.retrieveSismoData(this.currentGroup.location_ref)
         this.$refs.shmconfigTab.requestSHMGroupSensors(this.currentGroup)
         this.$refs.desvFreq.populateSelector(this.currentGroup);
         this.$refs.alertTab.populateSelector(this.currentGroup);
        })
        .catch((e) => {
          console.log("GroupDetails.vue::retrieveGroupDetails - Error recuperando el grupo")
          console.log(e);
        });
    },
  },
};
</script>
